import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'

const MenuButton = ({ onClick }) => (
  <IconButton color='inherit' aria-label='Menu' onClick={() => onClick()}>
    <MenuIcon />
  </IconButton>
)

export default MenuButton



// WEBPACK FOOTER //
// ./src/components/MenuButton.js